import React from "react";
import { Container, Button } from "react-bootstrap";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";

const LaunchPage = () => {
  return (
    <div className="launch-container">
      {/* Hero Section with Massive Text */}
      <div className="hero-section">
        <img
          src="/assets/557105.png"
          alt="Background"
          className="background-image"
        />
        <div className="hero-overlay"></div>
        <div className="hero-text">
          <h1>COMING SOON</h1>

          <div className="hero-line">
            <img
              src="/assets/logo1.png"
              alt="Sourabham Logo"
              className="sourabham-logo"
            />
            <div className="subtext-wrapper">
              <h5>
                <span className="bauhauss-font">range from</span>
                <span className="edingu-style">Indus Kitchens</span>
              </h5>
            </div>
          </div>

          <div className="hero-textt">
            <h5>
              <span className="bauhausss-font p-2 ">
                few more days to experience the
              </span>
              <span className="edinguu-style">
                Dance of Spices on your Palate
              </span>
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LaunchPage;
